import { bbSubDomain } from '../../../utilities/UrlPaths';

export const DISPUTES_ACTIONS = {
  REOPEN: 'reopen',
  CLOSE: 'close',
  CANCEL: 'cancel',
  SEND: 'send'
};

export const DISPUTES_FILTERS = {
  OPEN_DISPUTES: 'openDisputes',
  PAST_SIX_MONTHS: 'pastDisputes?days=180',
  PAST_YEAR: 'pastDisputes?days=360',
  ALL_DISPUTES: 'disputes'
};

export const VIEW_DISPUTE_URL = '/customers/viewDisputes';
export const SELECTED_ALL_DISPUTES = 'ALL';

export const BACK_TO_VIEW_DISPUTES = 'Back to View Disputes';

export const BIDDER_SUCCESS_MESSAGES = {
  send: 'Your message has been sent!',
  close: 'Your dispute(s) have been successfully closed!',
  cancel: 'Your dispute(s) have been successfully canceled!',
  reopen: 'Your dispute(s) have been successfully reopened!'
};

export const AGREEMENT_LINK = `https://${bbSubDomain()}.invaluableauctions.com/MSA_8_2018.pdf`;

export const getSubmitDisputesFlags = (disputes, selectedDisputes) => {
  const disputeArray = selectedDisputes.map(disputeID =>
    disputes.find(({ disputeInfo }) => disputeInfo.disputeID === disputeID)
  );

  return {
    disputeArray,
    hasNonCloseableDisputes: disputeArray.some(
      ({ disputeInfo }) => !disputeInfo.closeable && disputeInfo.openDispute
    ),
    hasSomeOpenDisputes: disputeArray.some(({ disputeInfo }) => disputeInfo.openDispute),
    hasAllOpenDisputes: disputeArray.every(({ disputeInfo }) => disputeInfo.openDispute),
    hasEbayBidders: disputeArray.some(({ bidderInfo }) => bidderInfo.ebay),
    allEbayBidders: disputeArray.every(({ bidderInfo }) => bidderInfo.ebay),
    allClosedDisputes: disputeArray.every(({ disputeInfo }) => !disputeInfo.openDispute)
  };
};

export const getSubmitDisputeError = ({ flags, selectAction, isSuperUser, sendMessage }) => {
  const {
    allEbayBidders,
    allClosedDisputes,
    hasAllOpenDisputes,
    hasEbayBidders,
    hasNonCloseableDisputes,
    hasSomeOpenDisputes
  } = flags;

  if (!isSuperUser && selectAction === DISPUTES_ACTIONS.CLOSE && hasNonCloseableDisputes) {
    return 'This action cannot be completed as it is outside the time-frame.';
  }

  if (hasEbayBidders && selectAction === DISPUTES_ACTIONS.REOPEN) {
    return 'You cannot reopen a dispute against an eBay bidder.';
  }

  if (!hasAllOpenDisputes && !allClosedDisputes) {
    return 'You cannot perform an action on open and past disputes at the same time. Please select only open disputes or past disputes and try again.';
  }

  if (hasSomeOpenDisputes && selectAction === DISPUTES_ACTIONS.REOPEN) {
    return 'Not a valid action on an open dispute.';
  }

  if (selectAction !== DISPUTES_ACTIONS.REOPEN && allClosedDisputes) {
    return 'You must reopen a dispute to send a message, close, or cancel.';
  }

  if (selectAction === DISPUTES_ACTIONS.SEND) {
    if (allEbayBidders) {
      return 'To reach an eBay bidder, please send a message from the eBay message center or correspond directly by email or phone.';
    }
    if (sendMessage === '') {
      return 'Message is required.';
    }
  }
};

export const formatPhoneNumber = phone => {
  let phoneParts = [];

  if (phone.match(/\d+-\d+-\d+/)) {
    phoneParts = phone.split('-');
  } else if (phone.match(/\d+\s\d+\s\d+/)) {
    phoneParts = phone.split(' ');
  } else if (phone.match(/\d+\.\d+\.\d+/)) {
    phoneParts = phone.split('.');
  } else if (phone.match(/\d{9}/)) {
    phoneParts = [phone.substring(0, 3), phone.substring(3, 6), phone.substring(6)];
  }

  if (phoneParts.length === 3) {
    return `(${phoneParts[0]}) ${phoneParts.slice(1).join('-')}`;
  }

  return phone;
};
